import type { FC, ReactNode } from "react";

import { CardContent } from "../card";
import { EmailDraftEditor, type EmailDraftEditorProps } from "./email-draft-editor";
import { EmailDraftRecipients } from "./email-draft-recipients-panel";
import { EmailDraftSubject } from "./email-draft-subject";

export interface EmailDraftContentProps extends EmailDraftEditorProps {
  /** Replaces the subject input; `null` hides the row. */
  subjectRow?: ReactNode;
}

/** Recipients, subject, and body. Render it inside the host's `Form`. */
export const EmailDraftContent: FC<EmailDraftContentProps> = ({ subjectRow, ...editorProps }) => {
  const subject = subjectRow === undefined ? <EmailDraftSubject /> : subjectRow;

  return (
    <CardContent className="flex-1 flex flex-col pb-0 min-h-0">
      <EmailDraftRecipients />

      {subject && <div className="border-y flex-0">{subject}</div>}

      <EmailDraftEditor {...editorProps} />
    </CardContent>
  );
};
